import React, { useEffect, useState } from 'react';
import RightChevron from '@src/common/assets/arrow-icons/ic_keyboard_arrow_right.svg';
import PropTypes from 'prop-types';
import LeftChevron from '@src/common/assets/arrow-icons/ic_keyboard_arrow_left.svg';

import { styled } from '@uhg-abyss/web/tools/styled';
const Wrapper = styled('div', {
  marginBottom: '64px',
  paddingRight: '20px',
  paddingLeft: '30px',
});

const HeadingRelatedApi = styled('h4', {
  minHeight: '24px',
  color: 'rgb(0, 38, 119)',
  fontFamily: 'AbyssUHCSerif, Georgia Bold, serif !important',
  fontSize: '24px',
  fontWeight: 'bold',
  lineHeight: '24px',
});

const Container = styled('div', {
  minHeight: '100%',
  marginTop: '24px',
  marginBottom: '10px',
  display: 'flex',
  position: 'relative',
  columnGap: '20px',
});

const ApiItem = styled('div', {
  flexBasis: '100%',
  minHeight: '242px',
  background: 'rgb(255, 255, 255)',
  border: '1px solid rgb(219, 219, 219)',
  boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.05)',
  borderRadius: '4px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  padding: '32px',
});

const DescP = styled('p', {
  color: 'black',
  marginBottom: '0',
  fontWeight: 600,
});

const ApiTitle = styled('h3', {
  color: 'rgb(0, 38, 119)',
  fontSize: '20px !important',
  fontWeight: '600 !important',
  lineHeight: '32px !important',
  marginBottom: '10px !important',
});

const NextSlide = styled('input', {
  position: 'absolute',
  right: '-50px',
  top: '95px',
  width: '50px',

  '&:focus': {
    border: 'none',
    boxShadow: 'none',
  },
});

const PrvSlide = styled('input', {
  position: 'absolute',
  left: '-50px',
  top: '95px',
  width: '50px',

  '&:focus': {
    border: 'none',
    boxShadow: 'none',
  },
});

const IndexCircles = styled('div', {
  height: '24px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  cursor: 'pointer',
});

const NonSelectedCircle = styled('div', {
  width: '8px',
  height: '8px',
  background: 'rgb(51, 51, 51)',
  borderRadius: '60px',
  margin: '0 10px',
  outline: 'none',
});

const SelectedCircle = styled('div', {
  width: '12px',
  height: '12px',
  background: 'rgb(25, 110, 207)',
  borderRadius: '60px',
  margin: '0 10px',
  outline: 'none',
});

export const TestimonialsMobileView = ({ initialData }) => {
  const [relatedAPIs, setRelatedAPIs] = useState([]);
  const [indexesList, setIndexesList] = useState([]);
  const [selectedIndex, setSelectedIndex] = useState([]);
  const [circleSelector, setCircleSelector] = useState(0);

  const slideFn = (data) => {
    const mainData = [...initialData];
    const nextMAin = data.map((el) => {
      return mainData[el];
    });
    setRelatedAPIs(nextMAin);
    setCircleSelector(data[0]);
  };

  useEffect(() => {
    const oneIndexList = [];
    for (let i = 0; i < initialData.length; i++) {
      oneIndexList.push(i);
    }

    const indexes = [];
    for (let i = 1; i < 13; i++) {
      indexes.push(...oneIndexList);
    }

    slideFn(indexes.slice(indexes.length / 2, indexes.length / 2 + 1));
    setIndexesList(indexes);
    setSelectedIndex(indexes.length / 2);
  }, []);

  const slideHandler = (type) => {
    const newIndexesList = [...indexesList];
    let data;
    if (type === 'next') {
      data = newIndexesList.slice(selectedIndex + 1, selectedIndex + 2);
      setSelectedIndex(selectedIndex + 1);
    } else {
      data = newIndexesList.slice(selectedIndex - 1, selectedIndex + 0);
      setSelectedIndex(selectedIndex - 1);
    }
    slideFn(data);
  };

  const circleHandler = (i) => {
    if (i > circleSelector) {
      const count = i - circleSelector;
      const newSelectedIndex = selectedIndex + count;
      const finalData = [...indexesList].slice(
        newSelectedIndex,
        newSelectedIndex + 1
      );
      setSelectedIndex(newSelectedIndex);
      slideFn(finalData);
    } else if (i < circleSelector) {
      const count = circleSelector - i;
      const newSelectedIndex = selectedIndex - count;
      const finalData = [...indexesList].slice(
        newSelectedIndex,
        newSelectedIndex + 1
      );
      setSelectedIndex(newSelectedIndex);
      slideFn(finalData);
    }
  };

  return (
    <Wrapper>
      <HeadingRelatedApi>Testimonials</HeadingRelatedApi>
      <Container>
        {relatedAPIs.map((el, i) => {
          return (
            <ApiItem>
              <ApiTitle>{el.title}</ApiTitle>
              <DescP>{el.desc}</DescP>
            </ApiItem>
          );
        })}
        {initialData.length > 1 && (
          <NextSlide
            type="image"
            src={RightChevron.src}
            alt="next-image"
            onClick={() => {
              return slideHandler('next');
            }}
          />
        )}
        {initialData.length > 1 && (
          <PrvSlide
            type="image"
            src={LeftChevron.src}
            alt="previous-image"
            onClick={() => {
              return slideHandler('prv');
            }}
          />
        )}
      </Container>
      {initialData.length > 1 && (
        <IndexCircles>
          {initialData.map((el, i) => {
            const Circle =
              i === circleSelector ? SelectedCircle : NonSelectedCircle;
            return (
              <Circle
                key={i}
                onClick={() => {
                  return circleHandler(i);
                }}
                role="button"
                aria-label="test"
                tabIndex={i}
              />
            );
          })}
        </IndexCircles>
      )}
    </Wrapper>
  );
};

TestimonialsMobileView.propTypes = {
  initialData: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string,
      linkLabel: PropTypes.string,
      link: PropTypes.string,
    })
  ),
};

TestimonialsMobileView.defaultProps = {
  initialData: [],
};
